import React, { useState, useEffect } from "react";

const ManageDues = () => {
  const [responseMessage, setResponseMessage] = useState("");
  const [saleHistory, setSaleHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAcceptDue, setShowAcceptDue] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [receivedAmount, setReceivedAmount] = useState("");

  useEffect(() => {
    // Fetch reports only for the logged-in user
    const fetchSaleHistory = async () => {
      try {
        const response = await fetch(
          `https://api.swalokgroup.com/api/get-sale-invoice`
        );
        if (response.status !== 200) {
          throw new Error("Failed to fetch invoices");
        }
        const data = await response.json();

        const filteredSales = data.filter((sale) => sale.due > 0);

        setSaleHistory(filteredSales);
      } catch (error) {
        console.log(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSaleHistory();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };

  const handleEditDue = (invoice) => {
    setSelectedInvoice(invoice);
    setReceivedAmount("");
    setShowAcceptDue(true);
  };

  const handleDueSubmit = async (e) => {
    e.preventDefault();
    setResponseMessage("");

    if (!receivedAmount || isNaN(receivedAmount) || receivedAmount <= 0) {
      setResponseMessage("Please enter a valid amount.");
      setTimeout(() => {
        setResponseMessage("");
      }, 1000);
      return;
    }

    const newAmountReceived =
      parseFloat(receivedAmount) + parseFloat(selectedInvoice.received);

    try {
      const response = await fetch(
        `https://api.swalokgroup.com/api/update-sale-invoice`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: selectedInvoice.id,
            received: newAmountReceived,
            due: selectedInvoice.due - parseFloat(receivedAmount),
          }),
        }
      );

      if (response.ok) {
        setSaleHistory((prevHistory) =>
          prevHistory.map((sale) =>
            sale.id === selectedInvoice.id
              ? {
                  ...sale,
                  amount_received: newAmountReceived,
                  due: selectedInvoice.due - parseFloat(receivedAmount),
                }
              : sale
          )
        );
        setResponseMessage("Due Amount received successfully!");
        setTimeout(() => {
          setResponseMessage("");
          setShowAcceptDue(false);
        }, 1000);
      } else {
        setResponseMessage("Failed to update the due amount received.");
        setTimeout(() => {
          setResponseMessage("");
        }, 1000);
      }
    } catch (error) {
      console.error(error.message);
      alert("An error occurred while updating the amount.");
    }
  };

  return (
    <>
      <section className="py-5">
        <div className="container">
          <div className="sec-subheading">
            <hr />
            <span>Manage Due Payments</span>
            <hr />
          </div>

          <div className="table-responsive text-center mt-4">
            <table className="w-100">
              <thead>
                <tr className="bg-light para-text">
                  <th className="py-3 px-2">Invoice No</th>
                  <th className="py-3 px-2">Customer Name</th>
                  <th className="py-3 px-2">Date</th>
                  <th className="py-3 px-2">Plot Details</th>
                  <th className="py-3 px-2">Total</th>
                  <th className="py-3 px-2">Due</th>
                </tr>
              </thead>

              <tbody>
                {loading && (
                  <tr>
                    <td colSpan="8" className="py-3 px-2">
                      Loading sale...
                    </td>
                  </tr>
                )}

                {saleHistory.length === 0 ? (
                  <tr>
                    <td colSpan="8" className="py-3 px-2">
                      No Sale History found.
                    </td>
                  </tr>
                ) : (
                  saleHistory.map((sale, index) => (
                    <tr
                      className="text-muted para-text text-capitalize"
                      key={index}
                    >
                      <td className="py-3 px-2">{sale.id}</td>
                      <td className="py-3 px-2">{sale.cust_name}</td>
                      <td className="py-3 px-2">
                        {formatDate(sale.sale_date)}
                      </td>
                      <td className="py-3 px-2">{`Plot No: ${
                        JSON.parse(sale.plot_details)[1]
                      }, ${JSON.parse(sale.plot_details)[2]}`}</td>
                      <td className="py-3 px-2">₹ {sale.total}</td>
                      <td className="py-3 px-2 text-danger cursor-pointer">
                        ₹ {sale.due}
                        &nbsp;&nbsp;
                        <span onClick={() => handleEditDue(sale)}>
                          <i className="fa-solid fa-pen-to-square fs-5 text-black"></i>
                        </span>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          {/* table ends */}
        </div>
      </section>

      {showAcceptDue && (
        <section
          className="popup-area"
          onClick={() => {
            setShowAcceptDue(false);
            setSelectedInvoice(null);
          }}
        >
          <div className="popup-inner" onClick={(e) => e.stopPropagation()}>
            <div className="sec-subheading">
              <hr />
              <span>Accept Dues</span>
              <hr />
            </div>
            <p className="my-4">
              Invoice No: {selectedInvoice.id}
              <br />
              Due Amount: ₹ {selectedInvoice.due}
            </p>

            <form className="row g-3" onSubmit={handleDueSubmit}>
              <div className="col-12">
                <label className="text-muted">Receiving Amount</label>
                <input
                  type="number"
                  className="form-input"
                  placeholder="Enter amount to accept"
                  value={receivedAmount}
                  onChange={(e) => setReceivedAmount(e.target.value)}
                />
              </div>
              <div className="col-12 my-4 text-end">
                <button className="admin-btn py-2 px-3 rounded" type="submit">
                  Submit
                </button>
              </div>
            </form>
          </div>

          {responseMessage && (
            <div className="response-message d-flex justify-content-between">
              <p className="my-0 mx-auto">{responseMessage}</p>
              <p
                className="my-0 cursor-pointer"
                onClick={() => setResponseMessage(false)}
              >
                <i className="fa-solid fa-xmark"></i>
              </p>
            </div>
          )}
        </section>
      )}
    </>
  );
};

export default ManageDues;
